import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, query, property, state } from 'lit/decorators.js'
import { consume } from '@lit/context'
import { ifDefined } from 'lit/directives/if-defined.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { CSESlideIn } from '@cloudsuite/mosaic-elements'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { DEFAULT_ROLE_PERMISSIONS, RolePermissionsContext, type RolePermissions } from 'components/shared/role/role-provider.js'
import 'components/discovery/pdp/order-history/order-history.js'

initializeIconsByRole({
  'csc-order-history-slide-in.link': { name: 'clock-rotate-left', style: 'light' },
})

@customElement('csc-order-history-slide-in')
export class CSCOrderHistorySlideIn extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ type: Number, attribute: 'product-id' })
  productId: number | null = null

  @consume({ context: RolePermissionsContext, subscribe: true })
  @state()
  private rolePermissions: RolePermissions = DEFAULT_ROLE_PERMISSIONS

  @query('cse-slide-in')
  slideIn!: CSESlideIn | null

  open() {
    this.slideIn?.open()
  }

  override render() {
    if (!this.rolePermissions.loggedIn) return nothing

    return html`
      <slot name="trigger" @click="${this.open}">
        <cse-link variant="primary" font-variant="body">
          <cse-icon slot="prefix" icon-role="csc-order-history-slide-in.link"></cse-icon>
          <slot></slot>
        </cse-link>
      </slot>

      <cse-slide-in size="default" placement="right">
        <div slot="header">
            ${t('slide_in_header', { ns: 'csc-order-history-slide-in', default: 'Order history' })}
        </div>
        <csc-order-history
          product-id="${ifDefined(this.productId ?? undefined)}"
        ></csc-order-history>
      </cse-slide-in>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-order-history-slide-in': CSCOrderHistorySlideIn
  }
}
